import { Notyf } from "notyf";
import theme from "../styles/theme";


export const searchTreeBailleur = (data, query, bailleursSelected) => {
    let bailleurs = bailleursSelected?.map(item => item?.libelleCourt?.toLowerCase())
    console.log(bailleurs)
    if (!query) return data.filter(a => !bailleurs?.includes(a.libelleCourt?.toLowerCase()))
  
    return data.filter(a => !bailleurs?.includes(a.libelleCourt?.toLowerCase()))
        .map(item => {
            const match = item?.raisonSociale?.toLowerCase().includes(query.toLowerCase()) ||
                item?.libelleCourt?.toLowerCase()?.includes(query.toLowerCase());
            if (match) {
                return {
                    ...item,

                };
            }

            return null;
        })
        .filter(Boolean); // retire les null
}

export const searchTreeHierarchie = (data, query) => {
    if (!query) return data;

    return data
        .map(item => {
            const match = item?.libelle?.toLowerCase()?.includes(query.toLowerCase()) ||
                item?.code?.toLowerCase().includes(query.toLowerCase());
            if (match) {
                return {
                    ...item,

                };
            }

            return null;
        })
        .filter(Boolean); // retire les null
}

export const bailleursTries = (bailleurs) => {
    let b = bailleurs.sort((a, b) => {
        const libA = a.raisonSociale.toLowerCase();
        const libB = b.raisonSociale.toLowerCase();
        if (libA < libB) return -1;
        if (libA > libB) return 1;
        return 0;
    });
    return b
}

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getHierarchieBailleur = (levelTemp, hierarchieBailleur) => {
    let temp = hierarchieBailleur.children
    let levelSpliceFirst = levelTemp.filter((item, index) => index > 0)
    let tempData = renameSousNiveau(temp, levelSpliceFirst)
    let data = addTestPropertyRecursive(tempData, levelTemp, 0)
   return flattenData(data, 0, levelTemp)
}

export const renameSousNiveau = (data, orderLevel) => {

    const renameRecursively = (items, level) => {
        return items.map(item => {
            let newItem = {};
            for (const key in item) {
                if (Array.isArray(item[key]) && level < orderLevel.length) {
                    newItem[orderLevel[level].libelle] = renameRecursively(item[key], level + 1);
                } else {
                    newItem[key] = item[key];
                }
            }
            return newItem;
        });
    };
    return renameRecursively(data, 0);
};

export const addTestPropertyRecursive = (data, level, n = 0) => {
    return data.map(item => {
        // Créez une copie de l'élément
        const newItem = { ...item };

        for (const key in newItem) {
            // Si la propriété est un tableau, ajoutez 'test'
            if (Array.isArray(newItem[key])) {
                newItem[key].map((sous_item, i) => {
                    sous_item[level[n].libelle] = item.libelle;
                })
                if (n > 0) {
                    for (let i = 0; i < n; i++) {
                        newItem[key].map((sous_item, j) => {
                            sous_item[level[i].libelle] = item[level[i].libelle]
                        })
                    }
                }

                newItem[key] = addTestPropertyRecursive(newItem[key], level, n + 1);
            }
        }

        return newItem;
    });
};

export const flattenData = (data, n = 0, level) => {
   
    let result = [];
    Array.isArray(data) && data.forEach(item => {
  
        const { [level[n + 1]?.libelle]: curent, ...rest } = item; 

        result.push(n == level.length-1 ? item : rest);

        if (curent && n < level.length - 1) {

            result = result.concat(flattenData(curent, n + 1, level));
        }


    });
    return result;
}

const getKeyForItem = (hierarchical, niveau, item, n, m) => {
    let key = '';
    if (n > 0) {
        let temp = item
        const { [niveau[m - n]?.libelle]: curent, ...rest } = temp;

        let p = hierarchical?.filter((item) => item.libelle == curent)[0].code
        key = p + ":" + key;
        key = key + getKeyForItem(hierarchical, niveau, item, n - 1, m)
    } else
        key = item.code
    return key

}


export const getArbreJson = (dataTemp, level, codeBailleur) => {
    let data = [...dataTemp]
    let levelTemp = [...level]
    // on fait un map sur les niveaux juste pour avoir combien de niveaux on a
    levelTemp.map((niv, index) => {
        // d'abord on commences par le dernier niveau  inverser l'ordre des niveaux c'est plus facile a construire l'arbre
        let i = (levelTemp.length - 1) - index;
        // on cherches les lignes qui coresponde au niveau i en commancant par le dernier niveau ainsi de suite
        let orgsNext = data.filter(item => item.index == i);//2//1//0..
        //on map les lignes de chaque niveau i et puis on cherche le perent de chaque element et on ajoute l'element dans le parent
        orgsNext.map((element, index) => {
            //on evite le premier niveau car il n'a pas de parent
            if (i > 0) {
                //on cherche le parent de l'element 
                let parentElement = data.filter(item => item?.libelle == element[levelTemp[i - 1].libelle])[0];
                //mettre a jour le parent on ajoutant l'element

                let keyPath = codeBailleur+":"+getKeyForItem(data, levelTemp, element, element.index, element.index)+":"
                let elementTemp = { ...element, path: keyPath }
                let parentElementTemp = parentElement?.hasOwnProperty(levelTemp[i]?.libelle) ?
                    { ...parentElement, [levelTemp[i].libelle]: [...parentElement[levelTemp[i]?.libelle], elementTemp] } :
                    { ...parentElement, [levelTemp[i].libelle]: [elementTemp] }
                // on push le parent a jour dans le data
                data.push(parentElementTemp)
                let originalIndexOfParent = data.findIndex((item) => item == parentElement);
                let originalIndexElement = data.findIndex((item) => item == element);
                // data.splice(originalIndexElement, 1)
                //on supprime l'ancient parent vu que on l'a a jour apres avoir fais un push 
                data.splice(originalIndexOfParent, 1)
            }
        })
    })
    let resultat = data.filter(item => item.index == 0)
    resultat = resultat.map((item, index) => { return { ...item, path: codeBailleur+":"+item.code+":"} })

    return resultat

}


export const renameArrayProperties = (data) => {
    return data.map(item => {
        let newItem = {};
        for (const key in item) {
            if (Array.isArray(item[key])) {
                newItem['children'] = renameArrayProperties(item[key]);
            } else if (typeof item[key] === 'object' && item[key] !== null) {
                newItem[key] = renameArrayProperties([item[key]])[0];
            } else {
                newItem[key] = item[key];
            }
        }
        return newItem;
    });
};





export const owner_enqueteStatus = [
        {name: "IMPORTED" , label : "Réceptionée", color:theme.colors.gray}, //
        {name: "RECEIVED" , label : "Réceptionée", color:theme.colors.gray},
        {name: "TO_BE_CONTROLLED", label : "A contrôler", color:theme.colors.purple},
        {name: "CONTROLLED", label : "Contrôlée", color:theme.colors.gray},
        {name: "TO_BE_VALIDATED", label : "A valider", color:theme.colors.purple},
        {name: "VALIDATED", label : "Validée", color:theme.colors.gray},
        
    ]

export const getStatusBgColor = (state) => {

    let stat = owner_enqueteStatus.filter((s) => s.name == state);

  return stat[0]?.color;
};

export const getUserStatusBgColor = (state) => {

  let stat = user_invoiceStatus.filter((s) => s.name == state);
  return stat[0]?.color;
};

export const getStatusLabel = (state) => {
 
    let stat = owner_enqueteStatus.filter((s) => s.name == state);

  return stat[0]?.label;
};



export const formatDate = (date) => {

  if (date !== null ) {
      let newDate = new Date(date);

    let day =
      newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
    let month =
      newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1;
    return day + "/" + month + "/" + newDate.getFullYear();
  } else return null;
};

export const specFormatDate = (date) => {
  if (date !== null && date.valueOf() > 0) {
    let newDate = new Date(date);
    let day =
      newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
    let month =
      newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1;
    return newDate.getFullYear() + "-" + month + "-" + day;
  } else return null;
};



export const dayForIntervalMonthWithKey = () => {
  const moonLanding = new Date();
  var now = new Date();
  let firstDay = now.getDate();
  moonLanding.setMonth(moonLanding.getMonth() - 1);

  var i = 0;
  var daysOfYear = [];
  for (var d = moonLanding; d < now; d.setDate(d.getDate() + 1)) {
    let element = {};
    element.key = d.getDate();
    element.value = i;
    daysOfYear.push(element);
    i++;
  }
  return daysOfYear;
};

export const formatDateEur = (date) => {
  if (date !== null && date.valueOf() > 0) {
    let newDate = new Date(date);
    let day =
      newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
    let month =
      newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1;
    return newDate.getFullYear() + "-" + month + "-" + day;
  } else return null;
};

export const getStatusWithKey = (key, userType = null) => {
  const status = {
    NEW: "En cours",
    CONTROLLED:  "Contrôlée",
    RECEIVED:  "Réceptionée",   
  };
  return status[key];
};

export const showColumn = (column, field) => {
  if (column.filter((column) => column.field == field)[0]?.show == true)
    return true;
  else return false;
};

export const getAlignPosition = (columns, field) => {
  let alignItem = columns.filter((column) => column.field == field);
  return alignItem[0]?.alignSelf;
};

export const getEntityStatusWithKey = (key) => {
  const status = {
    ACTIVE: "Actif",
    INACTIVE: "Inactif",
    INPROGRESS: "En cours",
  };
  return status[key];
};

export const getChannelWithKey = (key) => {
  const status = {
    PAPER: "Papier",
    EMAIL: "Email",
   
  };
  return status[key];
};

export const getProfilsByEtape = (type) => {
    switch (type) {
        case 1:
            return [
                { name: "CourrierSeul", label: "Courrier seul", value: 1 },
                { name: "EmailSeul", label: "Email seul", value: 2 },
                { name: "CourrierEmail", label: "Courrier + Email", value: 4 },
                { name: "EmailPuisCourrier", label: "Email Puis Courrier", value: 7 },
            ]

            break;
        case 2:
            return [
                { name: "CourrierSeul", label: "Courrier seul", value: 1 },
                { name: "EmailSeul", label: "Email seul", value: 2 },
                { name: "CourrierEmail", label: "Courrier + Email", value: 4 },
                { name: "SmsSeul", label: "Sms seul", value: 3 },
                { name: "CourrierSms", label: "Courrier + Sms", value: 5 },
                { name: "SmsEmail", label: "Sms + Email", value: 6 },
                { name: "EmailPuisCourrier", label: "Email Puis Courrier", value: 7 },
                { name: "EmailPuisSms", label: "Email Puis Sms", value: 8 }, //
                { name: "SmsPuisCourrier", label: "Sms Puis Courrier", value: 9 },
                { name: "SmsPuisEmail", label: "Sms Puis Email", value: 10 },
                { name: "EmailSmsCourrier", label: "Email + Sms + Courrier", value: 11 },
                { name: "EmailPuisSmsPuisCourrier", label: "Email Puis Sms puis Courrier", value: 12 },
                { name: "SmsPuisEmailPuisCourrier", label: "Sms puis Email puis Courrier", value: 13 }
            ]
            break;
        case 3:
            return [
                { name: "CourrierSeul", label: "Courrier seul", value: 1 }
            ]
            break;
        default:
            return [];
    }
}


export const getTimeDate = (date) => {
  let newDate = new Date(date);
  let hour =
    newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
  let minutes =
    newDate.getMinutes() < 10
      ? "0" + newDate.getMinutes()
      : newDate.getMinutes();
  return hour + ":" + minutes;
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" })
    .format(number)
    .replaceAll(".", " ");
};



const updateDate = (a) => {
  let d = new Date(+a);
  let dateLimit = d.setDate(d.getDate() - 15);
  let dateLimitTime = d.getTime();
  return dateLimitTime;
};

export const validatDocs = (list, data) => {
  let newDate = new Date();
  var time = newDate.getTime();

  var validDoc = list?.map(function (e) {
    return {
      ...e,
      valide: data.some(
        (row) =>
          row.type === e.value && row.expirationDate > time && row.valid == "1"
      ),
    };
  });

  var validDoc2 = validDoc?.map(function (e) {
    return {
      ...e,
      alert: data.some(
        (row) =>
          row.type === e.value &&
          time > updateDate(row.expirationDate) &&
          row.valid == "1"
      ),
    };
  });
  var validDoc3 = validDoc2?.map(function (e) {
    return {
      ...e,
      attent: data.some(
        (row) =>
          row.type === e.value && row.valid == null && row.invalidate == null
      ),
    };
  });
  return validDoc3;
};

export const getNotyfObject = () => {
  const notyf = new Notyf({
    types: [
      {
        type: "warn",
        background: "orange",
        duration: 5000,
            dismissible: true,
            icon: {
          
                tagName: 'i',
                text: '⚠️',
              
            }
      },
      {
        type: "error",
        background: "indianred",
        duration: 5000,
        dismissible: true,
      },
    ],
  });
    notyf.warn = (message) => {
        notyf.open({ type: 'warn', message });
    };
  return notyf;
};

export const checkValidity = (value, rules) => {
    let isValid = true;

    if (!rules) {
        return true;
    }
  
    if (rules.required) {
        isValid = value?.trim() !== "" & value != null && isValid;
    } else {
        value = value ?? "";
    }

    if (rules.minLength) {
        isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
        isValid = value?.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
        //const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        //const pattern = /^[a-zA-Z0-9.!#$ %&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
         const pattern = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

        isValid = pattern.test(value) && isValid;
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid;
    }

    if (rules.isCodePostal) {
        const pattern = /^\d{5}$/;
        isValid = pattern.test(value) && isValid;
    }

    if (rules.isTelPortable) {
        const pattern = /^(06|07)\d{8}$/;
        isValid = pattern.test(value) && isValid;
    }

    if (rules.isTelFax) {
        const pattern = /^(01|02|03|04|05|08|09)\d{8}$/;
        isValid = pattern.test(value) && isValid;
    }

    return isValid;
};

function isValidFrenchMobile(num) {
    // Doit commencer par 06 ou 07 + 8 chiffres
    const formatOk = /^(06|07)\d{8}$/.test(num);

    // Rejeter les suites répétitives comme 0101010101 ou 0606060606
    const repetitive = /^(\d)\1+$/.test(num) || /^(\d\d)\1+$/.test(num);

    return formatOk && !repetitive;
}

export const removeObject = (array, object) => {
  if (array.indexOf(object) !== -1) array.splice(array.indexOf(object), 1);
};

export const isSameDay = (date1, date2) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

export const isToday = (date) => {
  return isSameDay(date, new Date());
};

export const isYesterday = (date) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return isSameDay(date, yesterday);
};

export const uniqueObjsArrayByUid = (arrayToFilter) => {
  const seen = new Set();
  const filteredArr = arrayToFilter.filter((el) => {
    const duplicate = seen.has(el.uid);
    seen.add(el.uid);
    return !duplicate;
  });
  return filteredArr;
};

export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const ucFirst = (toFormat) => {
  return toFormat.charAt(0).toUpperCase() + toFormat.slice(1);
};

export const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const convertFileToBase64 = (file) =>
  new Promise((resolve) => {
    let baseUrl = "";
    let reader = new FileReader();
    //convert the file tobase64 text
    reader.readAsDataURL(file);
    reader.onload = () => {
      //console.log('reader____', reader);
      baseUrl = reader.result;
      //console.log("baseUrl", baseUrl);
      resolve(baseUrl);
    };
    reader.onerror = (err) => console.log(err);
  });

